import { useQuery } from "@tanstack/react-query";
import ChannelConnectionsAdminService from "services/admin/channelConnections";

export const useGetChannelDetails = (channelConnectionID) => {
    return useQuery({
        queryKey: ['channel-details', channelConnectionID],
        queryFn: async () => {
            const { data } = await ChannelConnectionsAdminService.get(channelConnectionID);
            return data;
        },
    });
};